import type { MediaAsset, Restaurant, SiteData } from "../types";
import { menuCategories, menuItems } from "./menuCatalog";

export const restaurant: Restaurant = {
  id: "ortaya",
  name: "Ortaya",
  address: "Karl-Eilers-Straße 20",
  city: "33602 Bielefeld",
  phone: "0521 - 94 93 84 13",
  instagramUrl: "https://www.instagram.com/ortaya_kitchen/",
  facebookUrl: "https://www.facebook.com/OrtayaRestaurant/",
  heroTitle: "Mezze in die Mitte.",
  heroSubtitle: "Anatolische Küche, Grill & Drinks im Herzen von Bielefeld.",
};

export const media: MediaAsset[] = [
  {
    id: "line-art-sharing-table",
    type: "image",
    url: "/assets/instagram/ig-09.png",
    alt: "Line-Art Sharing Table",
    source: "instagram",
    tags: ["sharing", "line-art"],
    active: true,
    order: 1
  },
  {
    id: "manti",
    type: "image",
    url: "/assets/instagram/ig-02.png",
    alt: "Manti bei Ortaya",
    source: "instagram",
    tags: ["küche", "gericht"],
    active: true,
    order: 2
  },
  {
    id: "koefte-rezept",
    type: "image",
    url: "/assets/instagram/ig-03.png",
    alt: "Köfte auf dem Grillrost",
    source: "instagram",
    tags: ["grill", "köfte"],
    active: true,
    order: 3
  },
  {
    id: "grill-feuer",
    type: "image",
    url: "/assets/instagram/ig-04.png",
    alt: "Grill bei Ortaya",
    source: "instagram",
    tags: ["grill", "feuer"],
    active: true,
    order: 4
  },
  {
    id: "butter-koefte",
    type: "image",
    url: "/assets/instagram/ig-05.png",
    alt: "Köfte mit gebräunter Butter",
    source: "instagram",
    tags: ["grill", "köfte"],
    active: true,
    order: 5
  },
  {
    id: "bohnen",
    type: "image",
    url: "/assets/instagram/ig-06.png",
    alt: "Bohnen als Mezze",
    source: "instagram",
    tags: ["mezze", "küche"],
    active: true,
    order: 6
  },
  { id: "antalya-piyaz", type: "image", url: "/assets/instagram/ig-07.png", alt: "Antalya Piyaz bei Ortaya", source: "instagram", tags: ["mezze", "salat"], active: true, order: 7 },
  { id: "afiyet-olsun", type: "image", url: "/assets/instagram/ig-08.png", alt: "Mezze-Teller bei Ortaya", source: "instagram", tags: ["mezze", "gericht"], active: true, order: 8 },
  { id: "mezze-drinks-poster", type: "image", url: "/assets/instagram/ig-01.png", alt: "Ortaya Mezze und Drinks", source: "instagram", tags: ["grafik", "drinks"], active: true, order: 9 },
  { id: "flatbread-mezze", type: "image", url: "/assets/instagram/ig-10.png", alt: "Mezze auf Fladenbrot", source: "instagram", tags: ["mezze", "sharing"], active: true, order: 10 },
  { id: "gegrillter-pulpo", type: "image", url: "/assets/instagram/ig-11.png", alt: "Gegrillter Pulpo bei Ortaya", source: "instagram", tags: ["fisch", "pulpo"], active: true, order: 11 },
  { id: "coban-salatasi", type: "image", url: "/assets/instagram/ig-12.png", alt: "Ortayas Çoban Salatası", source: "instagram", tags: ["salat", "mezze"], active: true, order: 12 },
  { id: "girit-ezme", type: "image", url: "/assets/instagram/ig-13.png", alt: "Girit Ezme bei Ortaya", source: "instagram", tags: ["mezze", "gericht"], active: true, order: 13 },
  { id: "ottomans-soehne", type: "image", url: "/assets/instagram/ig-14.png", alt: "Ottomans Söhne Grafik", source: "instagram", tags: ["grafik", "marke"], active: true, order: 14 },
  { id: "os-kitchen-olive", type: "image", url: "/assets/instagram/ig-15.png", alt: "OS Kitchen Grafik in Oliv", source: "instagram", tags: ["grafik", "marke"], active: true, order: 15 },
  { id: "os-kitchen-rose", type: "image", url: "/assets/instagram/ig-16.png", alt: "OS Kitchen Grafik in Rosé", source: "instagram", tags: ["grafik", "marke"], active: true, order: 16 },
  { id: "sharing-table", type: "image", url: "/assets/instagram/ig-17.png", alt: "Geteilter Tisch bei Ortaya", source: "instagram", tags: ["sharing", "illustration"], active: true, order: 17 }
];

export const initialData: SiteData = {
  restaurant,
  categories: menuCategories,
  menuItems,
  media
};
